import config from '@/config';

export const RareSkill = (): JSX.Element => (
  <li className="flex items-center gap-10 px-16 py-8">
    <div className="flex h-32 w-32 items-center justify-center overflow-hidden rounded-full bg-purple-900/30">
      <img alt="Unicorn" src="/assets/unicorn.svg" />
    </div>
    <span className="body-1">
      <b>Rare Skill</b> - Few experts in {config.productName} have this knowledge.
    </span>
  </li>
);
